import React from 'react';
import SecondImage from "../assets/Blackwomen/BWI36.jpg";

function BookCall() {
    return (
      <section>
      <div className="mx-auto w-full sm:p-0 p-5">
        <div className="grid gap-6 sm:gap-6 md:grid-cols-2">
          {/* Left Column (Text and Buttons) */}
          <div className="flex flex-col items-start gap-2 md:py-24 md:px-24 max-w-[700px]">
            <div className="flex items-center rounded-md py-1">
              {/* <p className="text-sm uppercase mb-12">ABOUT</p> */}
            </div>
            <h4 className="mb-6 text-3xl font-semibold md:text-4xl md:mb-8 uppercase">
            Your Business Deserves Better Than a Template
            </h4>
            <p className="text-sm sm:text-xl">
            Tired of patchworking together tools that don’t fit? You’re not alone.
We build high-converting, custom-coded web platforms using React, Tailwind, and Firebase — crafted specifically for women growing bold, brilliant businesses.
            </p>


            <div className="flex flex-col gap-4 font-regular sm:flex-row mt-10">
              <a href="/contact" className="flex rounded-full items-center gap-4 bg-[#CFF098] px-8 py-2 text-black hover:opacity-60">
                <p>LET’S BUILD YOURS →</p>
              </a>
            </div>
            <p className='mt-6 mb-6 text-xl italic'>Discover how our custom applications that have helped over 200+ businesses thrive. Considering starting your app? Let's chat.</p>
          </div>

          {/* Right Column (Image) */}
          <div className="relative w-full h-[]">
            <img
              src={SecondImage}
              alt="Portrait of a smiling women entrepreneur - Woaom Web Design"
              className="absolute top-0 right-0 w-auto h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
      );
    }


export default BookCall